define((require) => {
    "use strict";

    const Ladda = require("ladda");
    const EditorEvents = require("shared/services/EditorEvents");
    const ImprovedView = require("editor/zbone/ImprovedView");
    const TemplateModel = require("ui/experience/TemplateModel");
    const NotificationBar = require("editor/ui/notificationbar/NotificationBar");
    const template = require("ui/experience/SaveTemplateModalView.tpl");

    const TEMPLATE_SAVED_TEXT = "This experience has been saved as a Template";
    const TEMPLATE_NOTIFICATION_CLOSE_DELAY = 7500;

    /**
     * View for saving the Template.
     * @author Yarolsav Ilin <@yil>
     */
    return ImprovedView.extend("SaveTemplateModalViewModel", {

        className: "save-template-modal",

        template,
        templateHelpers() {
            return {
                descriptionPlaceholder: TemplateModel.DEFAULT_DESCRIPTION
            };
        },

        bindings: {
            ".description": "description"
        },

        ui: {
            description: ".description",
            buttonOk: ".ok",
            buttonCancel: ".cancel",
            overlay: ".overlay"
        },

        events: {
            "click @ui.buttonCancel": "close",
            "click @ui.buttonOk": "_onOkClick"
        },

        modelEvents: {
            "change": "_onChanged",
            "request": "_onSyncStarted",
            "error sync": "_onSyncDone"
        },

        _buttonLadda: null,

        onRender() {
            this._onChanged();
            this._buttonLadda = Ladda.create(this.ui.buttonOk.get(0));
        },

        _onOkClick() {
            this._buttonLadda.start();

            const experienceJSON = this.options.experience.toJSON();
            const {
                id, version, pushedVersion, name
            } = experienceJSON;

            this.model
                .save({name, content: experienceJSON})
                .then(() => {
                    NotificationBar.open({message: TEMPLATE_SAVED_TEXT}, {tag: "template", closeDelay: TEMPLATE_NOTIFICATION_CLOSE_DELAY});

                    EditorEvents.trigger(EditorEvents.constants.SAVE_TEMPLATE, {
                        description: this.model.get("description"),
                        experienceId: id,
                        experienceVersion: version,
                        experiencePushedVersion: pushedVersion,
                        triggerOrigin: "SaveTemplateModalOkButton"
                    });
                })
                .always(() => {
                    this._buttonLadda.stop();
                    this.close();
                });
        },

        _onChanged() {
            const {buttonOk} = this.ui;

            if (this.model.isNew()) {
                buttonOk.removeClass("btn-danger");
                buttonOk.addClass("btn-warning");
                buttonOk.text("Create template");
            } else {
                buttonOk.removeClass("btn-warning");
                buttonOk.addClass("btn-danger");
                buttonOk.text("Update template");
            }
        },

        _onSyncStarted() {
            this.ui.overlay.removeClass("hidden");
        },

        _onSyncDone() {
            this.ui.overlay.addClass("hidden");
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/SaveTemplateModalView.js